import styled from 'styled-components';
import { StyledDemographicsItemsProps } from './types';

export const StyledDemographicsItemsContainer = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: start;
  flex-wrap: wrap;
`;

export const StyledDemographicsItem = styled.div<StyledDemographicsItemsProps>`
  width: 28%;
  padding: ${props => props.theme.spacing.medium};
  margin-right: ${props => props.theme.spacing.medium};
  margin-bottom: ${props => props.theme.spacing.medium};
  box-shadow: ${props => props.theme.shadow.position}
    ${props => props.theme.shadow.color};
  background-color: ${props => props.theme.colors.light};
  border-radius: ${props => props.theme.border_radius.standard};
  text-align: center;
  position: relative;
  cursor: pointer;
`;

export const StyledDraggableIcon = styled.div<StyledDemographicsItemsProps>`
  position: absolute;
  top: ${props => props.theme.spacing.small};
  left: ${props => props.theme.spacing.small};
`;
